<div class="chat-page">
  <div class="chat-page__hero">
    <h1 class="chat-page__headline">
      <span class="chat-page__headline">Another day, another</span>
      <span class="chat-page__headline" style="display: inline;">change to optimized<span class="chat-page__headline--accent" style="font-weight: 700;">.</span></span>
    </h1>
  </div>

  <section class="chat-card chat-card--prompt" aria-labelledby="chat-card-prompt-label">
    <div class="chat-card__label-wrapper">
      <textarea
        id="chat-card-prompt-label"
        class="chat-card__textarea"
        rows="1"
        placeholder="Ask Lilo to show what’s working (and not)..."
        [(ngModel)]="promptText"
        (keyup.enter)="sendPrompt()"
        [disabled]="isSending"
      ></textarea>
    </div>

    <div class="chat-card__content" style="display: flex; align-items: center; justify-content: space-between;">
        <!--
        <div class="chat-card__chips">
        <button
          *ngFor="let chip of chips"
          type="button"
          class="chat-chip"
          [ngClass]="{
            'chat-chip--active': chip.state === 'active',
            'chat-chip--inactive': chip.state === 'inactive'
          }"
          (click)="toggleChip(chip)"
        >
          <img
            class="chat-chip__toggle"
            [src]="chip.state === 'active' ? 'assets/chat/toggle-on.svg' : 'assets/chat/toggle-off.svg'"
            [alt]="chip.state === 'active' ? 'Toggle on' : 'Toggle off'"
          />
          <span class="chat-chip__label">{{ chip.label }}</span>
        </button>
      </div>
      
      -->
      <button class="chat-card__send" type="button" aria-label="Send prompt" (click)="sendPrompt()" [disabled]="isSending || !promptText.trim()">
        <img src="assets/chat/arrow-up-right.svg" alt="Send" />
      </button>
    </div>
  </section>

  <!--
  <section class="chat-card chat-card--library" aria-labelledby="chat-card-library-label">
    <div class="chat-card__header">
      <span id="chat-card-library-label" class="chat-card__title">Prompt Library</span>
      <button class="chat-card__dropdown" type="button" aria-label="Open prompt library options">
        <img src="assets/chat/icon-chevron.svg" alt="Dropdown" />
      </button>
    </div>

    <article class="chat-card__entry" aria-labelledby="chat-card-entry-title">
      <div class="chat-card__entry-header">
        <div class="chat-card__entry-title">
          <img class="chat-card__entry-stack" [src]="baseIcon" alt="Stack shadow" />
          <img class="chat-card__entry-stack" [src]="midIcon" alt="Stack mid" />
          <img class="chat-card__entry-stack" [src]="topIcon" alt="Stack top" />
          <h2 id="chat-card-entry-title">Email Flow Audit</h2>
        </div>
        <img src="assets/chat/caret.svg" alt="Caret" />
      </div>
      <p>
        Lorem ipsum dolor sit amet consectetur ipsum quam ultricies nec nunc vulputzate morbi sem in pulvinar ut lurna
        cras hace viverra euismod pharetra tincidunt quisque et.
      </p>
    </article>
  </section>
  -->
</div>


